import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
import { Link, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
import SmallLoading from '../element/SmallLoading';
// helpers
import { addBreadcrumbSchema, resultInfo } from '../helpers';

const CompanyProfile = () => {
  const { id } = useParams();
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState([]);
  const [companyJobs, setCompanyJobs] = useState([]);
  const [smallLoading, setSmallLoading] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);

  const getCurrentMonthYear = () => {
    const months = [
      'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень',
      'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень',
    ];

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = months[currentDate.getMonth()];

    return `${month} ${year}`;
  };

  const handlePageChange = async page => {
    try {
      setSmallLoading(true);
      setPagination(prev => ({
        ...prev,
        current_page: page,
      }));

      const response = await axios.get(
        BaseApi + `/candidates/companyprofile/${id}`,
        {
          params: {
            page,
            per_page: 20,
          },
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      const element = document.getElementById('vacansiesHeader');

      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offset = 90;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }

      if (response.data.status === 200) {
        setPagination(response.data.response.meta);
        setCompanyJobs(response.data.response.jobDetails);
      } else {
        resultInfo('error', response.data.message, t('employerCreateJob.close'));
      }

      setSmallLoading(false);
    } catch (error) {
      const element = document.getElementById('vacansiesHeader');

      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offset = 90;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }

      setSmallLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + `/candidates/companyprofile/${id}`,
        {
          params: {
            page: 1,
            per_page: 20,
          },
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      const { meta, jobDetails, userDetails } = response.data.response;

      const metaTitle = document.querySelector('title');
      const metaDescription = document.querySelector('meta[name="description"]');
      const metaTitleValue = `${userDetails.company_name} з відкритими ${meta.total} вакансіями станом на ${getCurrentMonthYear()} | GRC.ua`; // eslint-disable-line
      const metaDescriptionValue = `${userDetails.company_name} працює в індустрії ${userDetails.industry?.map(i => i.label).join(', ')} і здійснює свою діяльність в ${userDetails.address ? userDetails.address : ''}. Ознайомтеся докладніше на сайті GRC.ua`; // eslint-disable-line

      if (metaTitle) {
        metaTitle.textContent = metaTitleValue;
      }

      if (metaDescription) {
        metaDescription.content = metaDescriptionValue;
      }

      setLoading(false);
      setPagination(meta);
      setCompanyJobs(jobDetails);
      setCompanyDetails(userDetails);
    } catch (error) {
      setLoading(false);

      console.error('Error getting company profile', error);
    }
  };

  useEffect(() => {
    getData();

    window.scrollTo(0, 0);

    const breadcrumbs = [
      { name: t('companyProfile.companyProfile') },
    ];

    const script = addBreadcrumbSchema(breadcrumbs);

    return () => {
      if (script) document.head.removeChild(script);
    };
  }, []); // eslint-disable-line

  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container'></div>
          ) : (
            <>
              <div className='blogPageSection1 text-center'>
                <h1>{t('companyProfile.companyProfile')}{' '}{companyDetails.company_name}</h1>
                <h6 className='text-muted mt-2'>
                  {' '}
                  <Link to='/' style={{ color: 'grey' }}>
                    {t('navHeaders.home')}
                  </Link>
                  {' / '}
                  {t('companyProfile.companyProfile')}
                </h6>
              </div>
              <div className='blogPageSection2 container'>
                <div className='row'>
                  <div className='row'>
                    <div className='col-md-9 col-lg-9'>
                      <div className='card-body companyProfileCardLeft standartListStyle'>
                        <div className='row'>
                          {
                            companyDetails.company_about
                              ? HTMLReactParser(companyDetails.company_about)
                              : ''
                          }
                        </div>
                        <div className='card-footer companyProfileCardFooter'>
                          <h5 className='companyProfileLocation text-muted'>
                            <i className='fa-sharp fa-solid fa-location-dot' />
                            {' '}
                            {t('companyProfile.location')}:
                            {' '}
                            {companyDetails.address}
                          </h5>
                          {
                            companyDetails.website
                              ? (
                                <h5 className='companyProfileContact text-muted'>
                                  <i className='fa-solid fa-globe' />
                                  {' '}
                                  {t('companyProfile.website')}:
                                  {' '}
                                  <a href={companyDetails.website} target='_blank' rel='noopener noreferrer noindex nofollow'>
                                    {companyDetails.website}
                                  </a>
                                </h5>
                              ) : ''
                          }
                        </div>
                      </div>
                      {
                        companyJobs?.length > 0 && (
                          <>
                            <h2 id='vacansiesHeader' className='ms-3 mb-3 mt-5'>
                              {t('companyProfile.jobPostedBy')}
                              {' '}
                              {companyDetails.company_name}
                            </h2>
                            {
                              smallLoading
                                ? (
                                  <div className='mb-4 text-center'>
                                    <SmallLoading />
                                  </div>
                                ) : (
                                  <div>
                                    {
                                      companyJobs?.map(i => (
                                        <div key={i.id}>
                                          <div className='card-body companyProfileCardLeft'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                              <div>
                                                <h4>{i.title}</h4>
                                                <h6 className='text-muted CPTPart2'>
                                                  <i className='fa-sharp fa-solid fa-location-dot' />
                                                  {' '}
                                                  {i.job_city}
                                                </h6>
                                              </div>
                                              <Link
                                                className='btn btn-primary button1'
                                                to={`/jobdescription/${i.jslug}/${i.cslug}`}
                                              >
                                                {t('companyProfile.detailsButton')}
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    }
                                    <div className='manageJobPagination'>
                                      <p className='text-muted empPaginationData'>
                                        {t('pagination.NoofRecords')}
                                        {' '}
                                        {pagination?.from ? pagination?.from : 0} - {pagination?.to ? pagination?.to: 0}
                                        {' '}
                                        {t('pagination.of')} {pagination?.total ? pagination?.total : 0}
                                      </p>
                                      <div className='d-flex justify-content-center empPaginationButton'>
                                        <button
                                          className='btn navButton1 me-2'
                                          disabled={pagination?.current_page === 1}
                                          onClick={() => handlePageChange(pagination?.current_page - 1)}
                                        >
                                          {t('pagination.Prev')}
                                        </button>
                                        <button
                                          className='btn navButton1'
                                          disabled={pagination?.to >= pagination?.total}
                                          onClick={() => handlePageChange(pagination?.current_page + 1)}
                                        >
                                          {t('pagination.Next')}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )
                            }
                          </>
                        )
                      }
                    </div>
                    <div className='col-md-3 col-lg-3'>
                      <div className='card-body companyProfileCardRight'>
                        <div className='row'>
                          <img
                            src={companyDetails.company_logo}
                            className='companyProfileCardRightImage'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </>
          )
      }
    </>
  );
};

export default CompanyProfile;
